/**
 * ProgressBar Component (Option 2: Block Style)
 *
 * A horizontal progress bar showing 7 steps as blocks.
 *
 * Props:
 * - currentStep: number (1-7) - current active step
 * - totalSteps: number - total number of steps (default: 7)
 */

import './ProgressBar.css'

function ProgressBar({ currentStep = 1, totalSteps = 7 }) {
  return (
    <div className="progress-bar">
      <div className="progress-blocks">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1
          const isCompleted = stepNumber < currentStep
          const isActive = stepNumber === currentStep

          return (
            <div
              key={stepNumber}
              className={`progress-block ${
                isCompleted ? 'completed' : isActive ? 'active' : ''
              }`}
              aria-label={`Step ${stepNumber}${
                isCompleted ? ' completed' : isActive ? ' active' : ''
              }`}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ProgressBar
